import styled from 'styled-components';
import ProfileDefaultSvg from '../../assets/settings/ic-profile-pic.svg';

const ProfileDefaultIcon = styled(ProfileDefaultSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '3.8rem'};
height: ${props => props.height || '3.8rem'};
margin: ${props => props.margin};
fill: ${props => props.fill};
`;

export default ProfileDefaultIcon;
